import { render, staticRenderFns } from "./VenueDangerZone.vue?vue&type=template&id=e65c494e&scoped=true&"
import script from "./VenueDangerZone.vue?vue&type=script&lang=js&"
export * from "./VenueDangerZone.vue?vue&type=script&lang=js&"
import style0 from "./VenueDangerZone.vue?vue&type=style&index=0&id=e65c494e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65c494e",
  null
  
)

export default component.exports